import PaperButton from 'ember-paper/components/paper-button';

export default class PersonButton extends PaperButton {
  // Params
  /**
   * Person supplies a person record to render a button for.
   *
   * @param {Model<module:@linc-technologies/linced-common/models/person>}
   */
  person = null;

  /**
   * primary configures the button to use the primary theme colour.
   *
   * @param {Boolean}
   */
  primary = false;

  /**
   * raised configures the button to have an elevation with a drop shadow.
   *
   * @param {Boolean}
   */
  raised = true;
}
